import { A48ActivityType } from "./a48-activity-type.enum";

export class A48CourseTypes {

    public activityTypes: {id: number, name: string}[] = [
        { id: A48ActivityType.HOURS,  name: 'Act 48 Professional Development Activity' },
        { id: A48ActivityType.CREDITS,  name: 'College Course'},
    ]

    public collegeCreditType: { id: number,  name: string }[] = [
        { id: 1, name: 'Semester Credit' },
        { id: 2, name: 'Quarter Credit' }
    ]

    public courseType: { id: number,  name: string }[] = [
      { "id": 57, "name": "Act 48 Professional Development" },
      { "id": 56,  "name": "PA Inspired Leadership (PIL)" },
      { "id": 55,  "name": "PA Inspired Leadership (PIL) Induction" }
    ];

    public cecPerformance: { id: number,  name: string }[] = [
        { "id": 1,  "name": "Foundations of Special Education" },
        { "id": 2,  "name": "Development and Characteristics of Learners" },
        { "id": 3,  "name": "Individual Learning Differences" },
        { "id": 4,  "name": "Instructional Strategies" },
        { "id": 5,  "name": "Learning Environments and Social Interactions" },
        { "id": 6,  "name": "Language" },
        { "id": 7,  "name": "Instructional Planning" },
        { "id": 8,  "name": "Assessment" },
        { "id": 9,  "name": "Professional and Ethical Practice" },
        { "id": 10,  "name": "Collaboration" },
        { "id": 11,  "name": "NA" },
    ];
}
